import * as React from 'react';
import SvgIcon from './SvgIcon';
import {IconProps} from './types';

export default class IconCheck extends React.Component<IconProps, {}> {
  public render() {
    return (
      <SvgIcon {...this.props} viewBox="0 0 19.884 16.024">
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth={3}
          d="M1126.667,213.518l7.526,5.816,4.541-5.752,5.722-7.248"
          transform="translate(-1125.749 -205.404)"
        />
      </SvgIcon>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SvgIcon/IconCheck.tsx